// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_aw-0";
export var optionCard = "_aw-1";